import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { catchError, combineLatest, map, Observable, of, switchMap, take } from 'rxjs';

import { FilterService } from '@services/filter.service';
import { ListDataResponse } from '@models/list.model';
import { FilterDataMessage } from '@models/filter-data.model';

export const listResolver: ResolveFn<Observable<{ data: FilterDataMessage; list: ListDataResponse }>> = (route, state) => {
  const filterService = inject(FilterService);
  const url = state.url;

  return filterService.getFilter().pipe(
    switchMap((filterData) => {
      filterService.loadUrlParams(url);
      filterService.setMakeModelsNames();
      filterService.setFuelGearboxBodyTypeNames();
      filterService.filterParamsChanged(true, false);

      return combineLatest([
        of(filterData),
        filterService.getList().pipe(
          catchError(() => {
            return of({ code: 400, message: { items: [], total: 0 } } as ListDataResponse);
          }),
        ),
      ]).pipe(
        map(([filterData, listData]) => {
          return {
            data: filterData,
            list: listData,
          };
        }),
        take(1),
      );
    }),
  );
};
